import { buildQuery } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/report";

const getData = (params: {
    logistId?: number | undefined;
    transportColumnId?: number | undefined;
    startDate: Date;
    endDate: Date;
    periodType: string;
}) => {
    const { startDate, endDate, logistId, transportColumnId, periodType } = params;
    const filter: {
        startedAt: { gt: Date };
        endedAt: { lt: Date };
        periodType: string;
        logistId?: number;
        transportColumnId?: number;
    } = {
        startedAt: { gt: startDate },
        endedAt: { lt: endDate },
        periodType,
    };

    if (logistId) {
        filter.logistId = logistId;
    }
    if (transportColumnId) {
        filter.transportColumnId = transportColumnId;
    }

    const query = buildQuery({ filter }).substr(1);
    return request(`${resource}/getDataQuery/OrganizationActivityDashboardReport/?paramsQuery=${query}`, {
        method: "GET",
    });
};

export { getData };
